/**
 * Business-Friendly Chat Messages
 * Clear, helpful messaging focused on business outcomes rather than technical details
 */

/**
 * Chat Error Messages - Clear, actionable error messages
 */
export enum ChatErrorMessages {
  WEBSITE_GENERATION_FAILED = '❌ We couldn\'t create your website:',
  WEBSITE_PUBLISHING_FAILED = '❌ We couldn\'t publish your website right now. Let\'s try again.',
  UNABLE_TO_PUBLISH = '❌ We ran into an issue publishing your website:',
  SOMETHING_WENT_WRONG = '❌ Something didn\'t work as expected. Let\'s try creating your website again.'
}

/**
 * Chat Timeout Messages - When deployment takes longer than expected
 */
export enum ChatTimeoutMessages {
  DEPLOYMENT_LONGER_EXPECTED = '⏰ Your website is taking a bit longer to go live than usual, but don\'t worry - this happens sometimes!',
  WEBSITE_MIGHT_BE_READY = '🌐 Your website might already be ready! Try visiting it here:',
  BOOKMARK_ARGOCD_URL = '💡 Save this link - your website should be available there shortly.',
  CHECK_BACK_MINUTES = '⏰ Your website should be ready in the next few minutes. We\'ll keep working on it in the background!'
}

/**
 * Chat Status Check Error Messages - When we can't check status but website might still work
 */
export enum ChatStatusCheckMessages {
  UNABLE_TO_CHECK_STATUS = '⚠️ We\'re having trouble checking the status, but your website might already be live!',
  TRY_VISITING_URL = '🌐 Try visiting your website:',
  WAIT_FOR_ARGOCD = '💡 If it\'s not ready yet, please wait just a few more minutes.',
  STATUS_CHECK_FAILED = '⚠️ We can\'t check the status right now, but your website should be ready soon.'
}

/**
 * Chat Failure Recovery Messages - When deployment fails but URL might still work
 */
export enum ChatFailureRecoveryMessages {
  DEPLOYMENT_ISSUE = '❌ We encountered a hiccup during the publishing process.',
  WEBSITE_MIGHT_BE_AVAILABLE = '🌐 However, your website might still be available at:',
  TRY_IN_FEW_MINUTES = '💡 Please try this link in a few minutes. Sometimes it takes a little extra time to fully activate.',
  CONTACT_SUPPORT = '📞 If your website isn\'t working after 15 minutes, our support team can help you get it sorted out.'
} 